module.exports = __webpack_public_path__ + "static/media/mglogonew.c4783d62.svg";